<template>
  <el-dialog
    class="customDialog ExportMarkerTable"
    title="字段筛选"
    :visible.sync="dialogVisible"
    :close-on-click-modal = 'false'
    append-to-body
    width="30%"
    :close-on-press-escape = 'false'
  >
    <el-table
      ref="multipleTable"
      stripe
      :data="_columns"
      height="100%"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
          type="selection"
          class="selection"
          :width="55*zoomFactor">
      </el-table-column>
      <el-table-column label="字段名称" prop="label" show-overflow-tooltip>
      </el-table-column>
      <template slot="empty">
        <Empty></Empty>
      </template>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <div v-if="!showBtn" class="shade"></div>
<!--      <a @click="dialogVisible = false" :href="baseurl + 'map/layer/mark/export/excel?layerId=' + this.params.layerId + '&propertyIds=' + this.params.propertyIds + '&params=' + encodeURI(JSON.stringify(filterParams))" class="exportBtn">导 出</a>-->
      <el-button type="primary" @click="downloadFile(baseurl + 'map/layer/mark/export/excel?layerId=' + params.layerId + '&propertyIds=' + params.propertyIds + '&params=' + encodeURI(JSON.stringify(filterParams)), tableName)">导出</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { exportData } from '@/api/marker'
import { downloadFile } from '@/utils/util'
// import { mapGetters } from 'vuex'
export default {
  name: 'ExportMarkerTable',
  props: {
    columns: {
      type: Array,
      default: null
    },
    layerId: {
      type: Number,
      default: null
    },
    filterParams: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data () {
    return {
      dialogVisible: false,
      params: {
        layerId: 0,
        propertyIds: []
      },
      baseurl: process.env.VUE_APP_API_BASE_URL,
      showBtn: true,
      tableName: ''
    }
  },
  computed: {
    _columns () {
      return this.columns
    },
    _layerId () {
      return this.layerId
    }
  },
  watch: {
    _layerId (newValue, oldValue) {
      this.params.layerId = newValue
    }
  },
  methods: {
    // 文件下載
    async downloadFile (url, name) {
      try {
        await downloadFile(url, name)
      } catch {
        this.$message.error('下载文件失败')
      }
    },
    open (tableName) {
      this.tableName = tableName
      console.log(tableName)
      this.dialogVisible = true
      this.params.layerId = this._layerId
      this.$nextTick(() => {
        this._columns.forEach((item) => {
          this.$refs.multipleTable.toggleRowSelection(item, true)
        })
      })
    },
    close () {
      this.dialogVisible = false
    },
    handleSelectionChange (v) {
      if (v.length === 0) {
        this.showBtn = false
      } else {
        this.showBtn = true
      }
      this.params.propertyIds = []
      if (v && v.length) {
        v.forEach(item => {
          console.log(item)
          if (item.type) {
            this.params.propertyIds.push(item.prop)
          }
        })
      } else {
        this.params.propertyIds = []
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.ExportMarkerTable{
  .el-dialog__body{
    height: 400px;
  }
  .exportBtn{
    display: inline-block;
    width: 80px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #ffffff;
    cursor: pointer;
    background-color: $primary-color;
    border-radius: 4px;
    margin-left: 15px;
  }
  .el-dialog__footer{
    position: relative;
  }
  .shade{
    width: 80px;
    height: 32px;
    background-color: rgba(51, 51, 51, 0.3);
    position: absolute;
    border-radius: 4px;
    right: 20px;
    z-index: 100;
    top: 0;
    cursor: not-allowed;
  }
}
</style>
